import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Blocks /projects/create when the user cannot create projects (e.g. default viewer). */
export const createProjectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canCreateProject()) {
    return true;
  }
  return router.parseUrl('/dashboard');
};
